import React from 'react';

export const BackIcon = ({height = 64, width=64, fill="#000000"}) => {

    return (
        <svg height={height} id="Layer_1" style={{enableBackground: "new 0 0 512 512"}} version="1.1" viewBox="0 0 512 512"
             width={width}><polygon fill={fill} points="352,128.4 319.7,96 160,256 160,256 160,256 319.7,416 352,383.6 224.7,256 "/></svg>


    )
};